import BaseMapper from './base';
import { Component, HeroSectionLightProps } from '../types';

enum TextLanguageFieldsEnum {
  boldTitle = 'boldTitle',
  lightTitle = 'lightTitle',
}

type TextLanguageFields = `${TextLanguageFieldsEnum}`;

class ModuleHeroSectionLight extends BaseMapper {
  public async generateComponent(): Promise<Component<HeroSectionLightProps>> {
    const props = this.getProps();

    const children: Component[] = [
      ...(await this.renderChildrenFromId()),
      ...(await this.renderChildren()),
    ];

    return {
      name: 'HeroSectionLight',
      props,
      childrens: children,
    };
  }

  private getProps(): HeroSectionLightProps {
    const props = {} as HeroSectionLightProps;

    Object.assign(
      props,
      this.mapTextLanguageFields<
        Pick<HeroSectionLightProps, TextLanguageFields>
      >({
        fieldsToMap: [
          { key: 'module_section_light_sub_title', mappedKey: 'lightTitle' },
          { key: 'module_bubble_title', mappedKey: 'boldTitle' },
        ],
      }),
    );

    return props;
  }
}

export default ModuleHeroSectionLight;
